import "./AsbestosCertificate.module.css";
import Header from "@/reusable_sections/Header";
import AsbestosCertificateRequest from "./sections/AsbestosCertificateRequest";
import AsbestattestHoeWerktHet from "./sections/AsbestattestHoeWerktHet";
import GratisOfferte from "./sections/GratisOfferte";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function AsbestosCertificatePage() {
  return <div>
      <Header />
      <AsbestosCertificateRequest />
      <AsbestattestHoeWerktHet />
      <GratisOfferte />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}